export default "__VITE_ASSET__DhpWysmF__"